export default {
  s: '%d detik',
  smicro: '%d dtk',
  smid: '%d dtk',

  ss: '%d detik',
  ssmicro: '%d dtk',
  ssmid: '%d dtk',

  m: '%d menit',
  mmicro: '%d mnt',
  mmid: '%d mnt',

  mm: '%d menit',
  mmmicro: '%d mnt',
  mmmid: '%d mnt',

  h: '%d jam',
  hmicro: '%d j',
  hmid: '%d jam',

  hh: '%d jam',
  hhmicro: '%d j',
  hhmid: '%d jam',

  d: '%d hari',
  dmicro: '%d h',
  dmid: '%d hari',

  dd: '%d hari',
  ddmicro: '%d h',
  ddmid: '%d hari',
};
